import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

import Layout from "../components/Layout/Layout";
import NavBar from '../components/NavBar/NavBar';

import { getFlipStatus } from "../api/getFlipStatus";
import { updateFlipStatus } from "../api/updateFlipStatus";

import notificationIcon from '../assets/notificationIcon.png';
import successIcon from '../assets/successIcon.png';
import chillIcon from '../assets/chillIcon.png';
import workoutIcon from '../assets/energy_modal.png';
import closeIcon from '../assets/closeIcon.png';
import multiTapIcon from '../assets/multiTapIcon.png';
import energyIcon from '../assets/energy.png';

import { formatNumber } from "../utils/formatNumber";
import { formatUserCount } from "../utils/formatUserCount";


const Flip = () => {
    const level = Number(localStorage.getItem("level"));
    const token = sessionStorage.getItem('token');
    const points = sessionStorage.getItem('points');
    const navigate = useNavigate();
    const [score, setScore] = useState(points);
    const [sliderValue, setSliderValue] = useState(100);
    const [mode, setMode] = useState(true);
    const [notification, setNotification] = useState('');
    const [notificationVisibile, setNotificationVisibile] = useState(false);
    const [notificationImage, setNotificationImage] = useState(notificationIcon);
    const [isLoading, setIsLoading] = useState(true);
    const [clanInfo, setClanInfo] = useState({});
    const [clan, setClan] = useState(false);
    const [gameValue, setGameValue] = useState(0);

    const handleSliderChange = (event) => {
        setSliderValue(event.target.value);
    };

    useEffect(() => {
        const setFlipStatus = async () => {
            const flipStatus = await getFlipStatus(token);
            setMode(flipStatus);
            setIsLoading(false);
        }
        setFlipStatus();
        if(sessionStorage.getItem("clanInfo") === "{}"){
            setClan(false);
            return;
        }
        setClan(true);
        setClanInfo(JSON.parse(sessionStorage.getItem("clanInfo")));
    }, []);

    useEffect(()=>{
        let val = Math.floor(score * 0.3);
        setGameValue(val < 500000 ? val : 500000);
    }, [score])

    const handleClickDouble = async () => {
        const flipBonus = Math.floor(sliderValue * gameValue / 100);
        const flipSuccess = await updateFlipStatus(token, flipBonus);
        setMode(false);
        if (flipSuccess) {
            setNotification('You Won!');
            setNotificationVisibile(true);
            setNotificationImage(successIcon);
            setScore(+score + +flipBonus);
            setTimeout(() => {
                setNotificationVisibile(false);
                setTimeout(() => setNotification(''), 3000);
            }, 2000);
        } else {
            setNotification('You Lost!');
            setNotificationVisibile(true);
            setNotificationImage(notificationIcon);
            // setScore(score - flipBonus);
            setTimeout(() => {
                setNotificationVisibile(false);
                setTimeout(() => setNotification(''), 3000);
            }, 2000);
        }
    }

    const handleClickContinue = () => {
        navigate('/boosts');
    }

    const handleClickJoinClan = () =>{
        navigate('/joinclan');
    }

    const handleClickClan = (id) => {
        navigate(`/joinClan/${id}`);
    };


    return (
        <Layout>
            {isLoading ? (
                <div className="loading-container">
                    <div className="spinner"></div>
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                    {clan ? (
                        <button style={{ width: '72%', marginLeft: "auto", marginRight: "auto", borderRadius: '18.75rem', background: 'rgba(140,140,140,0.1)', backdropFilter: 'blur(0.5rem)', WebkitBackdropFilter: 'blur(0.5rem)', marginBlock: '0.3125rem', padding: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', border: 'none', gap: '0.5rem' }} onClick={() => handleClickClan(clanInfo.id)} className='clan'>
                            <img src={clanInfo.profilePictureUrl} alt="Avatar" style={{ width: '2.5rem', height: '2.5rem', position: 'relative', borderRadius: '50%' }}>
                            </img>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3125rem', width: '100%' }}>
                                <span style={{ fontFamily: 'Poppins', fontWeight: '600', fontSize: '0.75rem', color: 'white', textAlign: 'start' }}>{clanInfo.clanName}</span>
                                {clanInfo.energyBonus > 0 && (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={energyIcon} alt="Energy Icon" style={{ width: '0.875rem', height: '0.875rem' }} />
                                        <span style={{ fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.5rem', color: 'white', marginLeft: '0.25rem' }}>+{clanInfo.energyBonus}</span>
                                    </div>
                                )}
                                {clanInfo.tapBonus > 0 && (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={multiTapIcon} alt="Multi Tap Icon" style={{ width: '0.875rem', height: '0.875rem' }} />
                                        <span style={{ fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.5rem', color: 'white', marginLeft: '0.25rem' }}>+{clanInfo.tapBonus}</span>
                                    </div>
                                )}
                            </div>
                            <span style={{ fontFamily: 'Poppins', fontWeight: '500', fontSize: '0.8125rem', color: 'white', opacity: '0.6' }}>{clanInfo.points===undefined?"":formatUserCount(clanInfo.points)}{clanInfo.points > 1000 && '+'}</span>
                        </button>
                    ) : (
                        <button style={{ width: '50%', marginLeft:"auto", marginRight:"auto" , display:"flex", justifyContent:"center" , borderRadius: '18.75rem', background: 'rgba(140,140,140,0.1)', backdropFilter: 'blur(0.5rem)', WebkitBackdropFilter: 'blur(0.5rem)', marginBlock: '0.3125rem', paddingBlock: '1rem', cursor: 'pointer', border: 'none', fontFamily: 'Poppins', color: 'white', fontSize: '1rem', fontWeight: '500' }} onClick={handleClickJoinClan} >🪐 Join Clan</button>
                    )}
                    <span style={{ marginTop: '0.3125rem', color: 'white', fontFamily: 'Poppins', fontSize: '2.5rem', fontWeight: '700', marginBottom: "0.3125rem" }}>{formatNumber(score)}</span>
                    <button style={{ backgroundColor: 'rgba(140, 140, 140, 0.1)', color: 'white', border: 'none', padding: '0.34375rem 2rem', fontFamily: 'Poppins', fontSize: '0.75rem', fontWeight: '500', borderRadius: '6.25rem', cursor: 'pointer' }} >Level {level}</button>
                    <div style={{ width: '88%', paddingInline: '1rem', marginBottom: '7rem' }}>
                        {mode ? (
                            <div style={{ marginTop: '2rem', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '1.25rem', background: 'rgba(140,140,140,0.1)', backdropFilter: 'blur(0.5rem)', WebkitBackdropFilter: 'blur(0.5rem)', padding: '0.5625rem' }}>
                                <button style={{ position: 'absolute', top: '1rem', right: '1rem', float: 'right', background: 'none', border: 'none', cursor: 'pointer' }} onClick={()=>{navigate("/boosts")}} >
                                    <img src={closeIcon} alt="Close Icon" style={{ width: '1.875rem', height: '1.875rem' }} />
                                </button>
                                <img src={chillIcon} alt="Chill Icon" style={{ width: '5rem', height: '5rem' }} />
                                <span style={{ marginTop: '1.1rem', fontFamily: 'Poppins', fontWeight: '600', fontSize: '1.2rem', color: 'white', textAlign: 'center' }}>Mooncoin Game x2</span>
                                <span style={{ marginTop: '1.1rem', fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.8rem', color: '#F1F1F1', textAlign: 'center' }}>Try your Luck to Double your Mooncoins and Level Up even Faster!</span>
                                <div>
                                    <span style={{ fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.8rem', color: '#F1F1F1' }}>Doubling Probability is </span>
                                    <span style={{ fontFamily: 'Poppins', fontWeight: '700', fontSize: '1.1rem', color: '#0064D7', background: 'linear-gradient(45deg, #5DA8FF, #0064D7)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>95%</span>
                                </div>
                                <div style={{ marginTop: '0.5rem', fontFamily: 'Poppins', fontWeight: '700', fontSize: '1.75rem', color: 'white' }}>{formatNumber(Math.floor(sliderValue * gameValue / 100))}</div>
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '0.5rem', position: 'relative', width: '80%', maxWidth: '37.5rem', marginLeft: 'auto', marginRight: 'auto' }}>
                                    <div style={{ position: 'relative', width: '100%' }}>
                                        <div style={{ height: '0.53125rem', backgroundColor: 'rgba(124, 162, 220, 0.47)', borderRadius: '6.25rem', position: 'absolute', top: '25%', width: '100%', zIndex: '1' }}></div>
                                        <div style={{ height: '0.8125rem', backgroundColor: 'transparent', borderRadius: '0.625rem', position: 'relative' }}>
                                            <div style={{ height: '100%', background: 'linear-gradient(to right, #5DA8FF, #0064D7)', borderRadius: '0.625rem', transition: 'width 0.001s linear', position: 'relative', zIndex: 2, width: `${sliderValue}%` }}></div>
                                            <div style={{ position: 'absolute', left: `${sliderValue}%`, top: '50%', transform: 'translate(-50%, -50%)', width: '1.25rem', height: '1.25rem', backgroundColor: '#fff', border: '0.125rem solid #0064D7', borderRadius: '50%', zIndex: 3, }} ></div>
                                        </div>
                                    </div>
                                    <input type="range" min="0" max="100" value={sliderValue} onChange={handleSliderChange} style={{ position: 'absolute', top: '50%', left: '0', width: '100%', height: '0.8125rem', opacity: '0', zIndex: '3', cursor: 'pointer' }} />
                                </div>
                                <button style={{ width: '88%', marginBottom:"8px" , background: 'linear-gradient(45deg, #5DA8FF, #0064D7)', paddingBlock: '0.9rem', border: 'none', marginTop: '2.1875rem', borderRadius: '18.75rem', color: 'white', fontFamily: 'Poppins', fontSize: '0.9rem', cursor: 'pointer', fontWeight: '600' }} onClick={handleClickDouble}>
                                    Double
                                </button>
                            </div>
                        ) : (
                            <div style={{ marginTop: '1.875rem', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '1.25rem', background: 'rgba(140,140,140,0.1)', backdropFilter: 'blur(0.5rem)', WebkitBackdropFilter: 'blur(0.5rem)', padding: '1.5625rem' }}>
                                <img src={workoutIcon} alt="Work Out Icon" style={{ width: '6.25rem', height: '6.25rem' }} />
                                <span style={{ marginTop: '1.5625rem', fontFamily: 'Poppins', fontWeight: '600', fontSize: '1.25rem', color: 'white', textAlign: 'center' }}>Loading...</span>
                                <span style={{ marginTop: '0.5625rem', fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.9rem', color: '#F1F1F1', textAlign: 'center' }}>Come back tomorrow or continue</span>
                                <span style={{ marginTop: '0.5625rem', fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.9rem', color: '#F1F1F1', textAlign: 'center' }}>tapping on the coin</span>
                                <button style={{ width: '88%', background: 'linear-gradient(45deg, #5DA8FF, #0064D7)', paddingBlock: '0.9rem', border: 'none', marginTop: '2.1875rem', borderRadius: '18.75rem', color: 'white', fontFamily: 'Poppins', fontSize: '0.9rem', cursor: 'pointer', fontWeight: '600' }} onClick={handleClickContinue}>
                                    Continue
                                </button>
                            </div>
                        )}

                    </div>
                    {notification && <div style={{ position: 'absolute', bottom: '6rem', zIndex: '2', width: '100%' }}>
                            <div style={{ marginInline: '1.875rem', background: 'rgba(140, 140, 140, 0.1)', backdropFilter: 'blur(1rem)', WebkitBackdropFilter: 'blur(0.5rem)', borderRadius: '18.75rem', paddingBlock: '0.8rem', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: notificationVisibile ? 1 : 0, transition: 'opacity 0.5s ease-out', pointerEvents: notificationVisibile ? 'auto' : 'none' }}>
                                <img src={notificationImage} alt='Notification Icon' style={{ width: '1.5625rem', height: '1.5625rem' }} />
                                <span style={{ fontFamily: 'Poppins', fontWeight: '600', fontSize: '1rem', color: 'white', marginLeft: '0.375rem' }}>{notification}</span>
                            </div>
                        </div>
                    }
                </div>
            )}
            {/* <div style={{height: '80px'}}></div> */}
            <NavBar />
        </ Layout >
    );
};

export default Flip;